import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[modal-host]',
    standalone: false
})

export class ModalContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {

   }
}
